import { customFetch } from "@/client/custom-fetch";

import {
  IChangePasswordResponse,
  IUserProfileResponse,
  TPasswordRequest,
  TUpdateProfileRequest,
} from "./settings.types";

export const settingsApi = {
  getUserProfile: (userId: string): Promise<IUserProfileResponse> => {
    return customFetch<IUserProfileResponse>(`/user/${userId}`, {
      method: "GET",
    });
  },

  updateProfile: (
    userId: string,
    data: TUpdateProfileRequest
  ): Promise<IUserProfileResponse> => {
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("mfaEnabled", data.mfaEnabled ? "1" : "0");
    formData.append("picturePath", data.picturePath || "");
    formData.append("personType", data.personType);
    formData.append("document", data.document);
    formData.append("whatsapp", data.whatsapp);

    if (data.mfaMethod) formData.append("mfaMethod", data.mfaMethod);
    if (data.file) formData.append("file", data.file);

    return customFetch<IUserProfileResponse>(`/user/${userId}/profile`, {
      method: "PUT",
      body: formData,
    });
  },

  changePassword: (
    userId: string,
    data: TPasswordRequest
  ): Promise<IChangePasswordResponse> => {
    return customFetch<IChangePasswordResponse>(
      `/user/${userId}/change-password`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          oldPassword: data.currentPassword,
          newPassword: data.newPassword,
        }),
      }
    );
  },
};
